import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { OcInfraModule, ResourceService } from '@diaas/ux-web';

@Component({
  selector: 'app-loans-table-data',
  templateUrl: './loans-table-data.component.html',
  styleUrls: ['./loans-table-data.component.scss']
})
export class LoansTableDataComponent implements OnInit {

  @Input() columns: { columnDef: string; header: string }[] = [];
  @Input() data: any[] = [];
  @Input() onClickPermission: boolean = false;
  resourceService: any;
  productType: any;
  @Output() rowDoubleClick = new EventEmitter<any>();

  constructor(public commonService: CommonService) { }

  ngOnInit() {
    this.resourceService = OcInfraModule.AppInjector.get(ResourceService);
    const policyDetails = this.resourceService.getResourceFromAliasName('policyDetails');
    this.productType = policyDetails.response.product_type;
  }

  get displayedColumns(): string[] {
    return this.columns.map(c => c.columnDef);
  }

  // Click on Loans particular row with Double click
  onRowDoubleClick(row) {
    const _lifePolicies = this.commonService._lifePolicies;
    if (_lifePolicies.includes(this.productType) && this.onClickPermission) {
      this.rowDoubleClick.emit(row);      
    }
  }

}
